export default __webpack_public_path__ + "static/media/photo-sample.7a1fd82b.jpg";